'use client';

import { RudderAnalytics } from '@rudderstack/analytics-js';

let rudderStack: RudderAnalytics | null = null;

const initRudderStack = () => {
  if (typeof window === 'undefined')
    throw new Error('Rudderstack client can only be initialized on the client');

  rudderStack = new RudderAnalytics();

  rudderStack.load(
    '2sRrhoVxar5UyW1uVjCy7veufVZ',
    'https://cleverprogcqak.dataplane.rudderstack.com'
  );

  rudderStack.ready(() => {
    console.log('We are all set!!!');
  });

  return rudderStack;
};

export const getRudderStack = () => {
  if (rudderStack) return rudderStack;
  return initRudderStack();
};
